import type { AppNotification } from '../types';
import type { ProjectScope } from '../../sync/project-scope';

function stringPayload(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function getNotificationScope(notification: AppNotification): ProjectScope | null {
  if (!notification.orgId || !notification.projectId) return null;
  return { orgId: notification.orgId, projectId: notification.projectId };
}

function buildRoute(path: string, scope: ProjectScope, extra: Record<string, string | null>): string {
  const params = new URLSearchParams();
  params.set('orgId', scope.orgId);
  params.set('projectId', scope.projectId);

  for (const [key, value] of Object.entries(extra)) {
    if (value) params.set(key, value);
  }

  return `${path}?${params.toString()}`;
}

export function buildNotificationRoute(notification: AppNotification): string | null {
  const scope = getNotificationScope(notification);
  if (!scope) return null;

  switch (notification.type) {
    case 'event-created':
      return buildRoute('/scheduler', scope, {
        eventId: stringPayload(notification.payload?.eventId),
      });
    case 'import-complete':
      return buildRoute('/show-structure', scope, {
        jobId: stringPayload(notification.payload?.jobId),
      });
    case 'mention':
      return buildRoute('/feed', scope, {
        postId: stringPayload(notification.payload?.postId),
        commentId: stringPayload(notification.payload?.commentId),
      });
    default:
      return null;
  }
}

export function getScopeFromNotificationRoute(path: string): ProjectScope | null {
  const queryIndex = path.indexOf('?');
  if (queryIndex === -1) return null;

  const params = new URLSearchParams(path.slice(queryIndex + 1));
  const orgId = params.get('orgId');
  const projectId = params.get('projectId');
  if (!orgId || !projectId) return null;

  return { orgId, projectId };
}
